var __vue_script__, __vue_template__
var __vue_styles__ = {}
__vue_script__ = require("!!babel-loader?{\"cacheDirectory\":true,\"presets\":[[\"env\",{\"modules\":false,\"targets\":{\"browsers\":[\"> 2%\"],\"uglify\":true}}]],\"plugins\":[\"transform-object-rest-spread\",[\"transform-runtime\",{\"polyfill\":false,\"helpers\":false}]]}!../../../../../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Date.vue")
__vue_template__ = require("!!vue-html-loader!../../../../../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Date.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
if (__vue_template__) {
__vue_options__.template = __vue_template__
}
if (!__vue_options__.computed) __vue_options__.computed = {}
Object.keys(__vue_styles__).forEach(function (key) {
var module = __vue_styles__[key]
__vue_options__.computed[key] = function () { return module }
})



//////////////////
// WEBPACK FOOTER
// ./app/statamic/resources/js/components/publish/MetaFields/Date.vue
// module id = 304
// module chunks = 0